<app-header></app-header>

<div class="page-content">
  <div class="mobile-body-container">
      <!-- IMAGE -->
    <!-- <div class="login-image-container">
      <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/ef03b7f9-6c3f-4067-c459-00ec5eb56900/public" alt="">
    </div> -->

    <div form [formGroup]="signin">
    
      <div *ngIf="!expired">
        <h1 class="webapp-title nomargin">{{'AUTH.REGISTER.TITLE' | translate}}</h1>
        <!-- <p>Crear usuario</p> -->
        <h3>{{loginObj.username}}</h3>
      </div>

      <div *ngIf="expired">
        <h1 class="webapp-title nomargin">{{'AUTH.FORGOT_PASSWORD.SEND_BUTTON' | translate}}</h1>
        <p>{{ 'AUTH.RESET_PASSWORD.ERRORS.INVALID_TOKEN' | translate }}</p>
      </div>

      <mat-card-content *ngIf="!isLoading()">

        <!-- EMAIL TO REQUEST A NEW LINK TO CREATE ACCOUNT -->
        <!-- EMAIL -->
        <mat-form-field *ngIf="!isLoading() &&  (!preRegistered || expired)" class="my-mat-form-field">
          <mat-label>{{'AUTH.LOGIN.EMAIL_PLACEHOLDER' | translate}} </mat-label>
          <input matInput placeholder="{{getTranslationFor('AUTH.REGISTER.EMAIL_PLACEHOLDER')}}" class="my-mat-fields" type="email" required formControlName="email" required (keyup.enter)="onKeyUp($event)">
        </mat-form-field>

        <mat-form-field *ngIf="!expired" class="my-mat-form-field">
          <mat-label>{{'AUTH.RESET_PASSWORD.NEW_PASSWORD_PLACEHOLDER' | translate}}</mat-label>
          <input matInput placeholder="{{getTranslationFor('AUTH.RESET_PASSWORD.NEW_PASSWORD_PLACEHOLDER')}}" class="my-mat-fields" formControlName="password" [type]="hide ? 'password' : 'text'" required (keyup.enter)="onKeyUp($event)">
          <mat-icon matSuffix (click)="hide = !hide" style="align-items: center;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>

        <!-- PASS CONFIRM -->
        <mat-form-field *ngIf="!expired" class="my-mat-form-field">
          <mat-label>{{'AUTH.RESET_PASSWORD.CONFIRM_NEW_PASSWORD_PLACEHOLDER' | translate}}</mat-label>
          <input matInput placeholder="{{getTranslationFor('AUTH.LOGIN.PASSWORD_PLACEHOLDER')}}"  class="my-mat-fields" formControlName="passwordConfirm" [type]="hide ? 'password' : 'text'" required (keyup.enter)="onKeyUp($event)">
          <mat-icon matSuffix (click)="hide = !hide" style="align-items: center;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>

        <!-- PASSWORD MATCH -->
        <div *ngIf="passwordConfirmInput.touched && passwordConfirmInput.errors?.mismatch">
          <small>Passwords do not match</small>
        </div>
        <!-- PASSWORD CONFIRM IS PRESENT -->
        <p *ngIf="signin.get('passwordConfirm')?.touched && !signin.get('passwordConfirm').value">
          Password confirmation is required.
        </p>

        <!-- VALIDATIONS -->
        <div class="password-checker">
          <ul>
            <li [class.valid]="passwordRequirements.minLength">At least 8 characters</li>
            <li [class.valid]="passwordRequirements.uppercase">An uppercase letter</li>
            <li [class.valid]="passwordRequirements.lowercase">A lowercase letter</li>
            <li [class.valid]="passwordRequirements.number">A number</li>
            <li [class.valid]="passwordRequirements.specialChar">A special character</li>
          </ul>
        </div>  
        
        <!-- TERMS AND CONDITIONS -->
        <app-accept-terms-policy-check (policyChecked)="onTermsChecked($event)"></app-accept-terms-policy-check>

      </mat-card-content>

      <div class="flex-col">
        <!-- REGISTER BUTTON -->
        <button (click)="firstLogin()" mat-button class="button button-fill color-dark button-round" [disabled]="!areFieldsFilled()" *ngIf="!showEmail && !expired">
          <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
          <span *ngIf="!isLoading()">{{'AUTH.REGISTER.REGISTER_BUTTON' | translate}}</span>
        </button>

        <!-- BUTTON TO RESEND LINK -->
        <button (click)="generateNewLink()" mat-button class="button button-fill color-dark button-round" [disabled]="!isEmailFilled()" *ngIf="expired">
          <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
          <span *ngIf="!isLoading()">{{'AUTH.FORGOT_PASSWORD.SEND_BUTTON' | translate}}</span>
        </button>
        
      </div>
    </div>
  </div>
</div>
